var COLORS;
(function (COLORS) {
    // Blue
    COLORS["BLUE_1100"] = "#304FAE";
    COLORS["BLUE_1000"] = "#182B63";
    COLORS["BLUE_900"] = "#223D8D";
    COLORS["BLUE_700"] = "#1F41B4";
    COLORS["BLUE"] = "#2355FC";
    COLORS["BLUE_500"] = "#4E85FF";
    COLORS["BLUE_400"] = "#70A7FF";
    COLORS["BLUE_300"] = "#98CAFF";
    COLORS["BLUE_200"] = "#BFDFFF";
    COLORS["BLUE_100"] = "#DBEFFF";
    COLORS["BLUE_50"] = "#E9F5FF";
    // Red
    COLORS["RED_800"] = "#B91C1C";
    COLORS["RED_700"] = "#991B1B";
    COLORS["RED_600"] = "#B91C1C";
    COLORS["RED"] = "#DC2626";
    COLORS["RED_400"] = "#EF4444";
    COLORS["RED_300"] = "#F87171";
    COLORS["RED_200"] = "#FCA5A5";
    COLORS["RED_100"] = "#FECACA";
    // Green
    COLORS["GREEN_700"] = "#0F863C";
    COLORS["GREEN_600"] = "#0EA546";
    COLORS["GREEN_500"] = "#19CE5C";
    COLORS["GREEN_400"] = "#42E67E";
    COLORS["GREEN_300"] = "#80F5AA";
    COLORS["GREEN_200"] = "#B8FACF";
    COLORS["GREEN_100"] = "#DAFEE6";
    // Yellow
    COLORS["YELLOW"] = "#FFB700";
    COLORS["YELLOW_500"] = "#FFD71B";
    COLORS["YELLOW_400"] = "#FFE846";
    COLORS["YELLOW_300"] = "#FFF485";
    COLORS["YELLOW_200"] = "#FFF9C5";
    COLORS["YELLOW_100"] = "#FFFEEA";
    // Orange
    COLORS["ORANGE"] = "#F56700";
    COLORS["ORANGE_500"] = "#FF840A";
    COLORS["ORANGE_400"] = "#FFA132";
    COLORS["ORANGE_300"] = "#FFC56D";
    COLORS["ORANGE_200"] = "#FFDEA5";
    COLORS["ORANGE_100"] = "#FFF0D3";
    // PURPLE
    COLORS["PURPLE"] = "#5938FB";
    COLORS["PURPLE_LIGHT"] = "#DCD4FF";
    // GREY
    COLORS["GREY_1000"] = "#191919";
    COLORS["GREY_900"] = "#383838";
    COLORS["GREY_800"] = "#434343";
    COLORS["GREY_700"] = "#515151";
    COLORS["GREY_600"] = "#666666";
    COLORS["GREY_500"] = "#818181";
    COLORS["GREY_450"] = "#978E8E";
    COLORS["GREY_400"] = "#A4A4A4";
    COLORS["GREY_300"] = "#C8C8C8";
    COLORS["GREY_200"] = "#E3E3E3";
    COLORS["GREY_150"] = "#EDEDED";
    COLORS["GREY_100"] = "#F7F7F7";
    COLORS["GREY_50"] = "#F6F6F6";
    // COMMON
    COLORS["WHITE"] = "#FFFFFF";
    COLORS["BLACK"] = "#000000";
})(COLORS || (COLORS = {}));
var COLORS$1 = COLORS;

export { COLORS$1 as default };
//# sourceMappingURL=colors.js.map
